jQuery(document).ready(function ($) {
	if (document.querySelector(".ARCHIVE-COACHES__header__map")) {
		window.initializeCoachesMap = function () {
			let map;
			const bounds = new google.maps.LatLngBounds();
			const mapOptions = {
				// mapTypeId: 'roadmap'
			};

			// Display a map on the page
			map = new google.maps.Map(
				document.getElementsByClassName("ARCHIVE-COACHES__header__map")[0],
				mapOptions
			);

			// Multiple Markers
			const markers = [];
			$("[data-marker]").each((i, element) => {
				const [lat, lng] = $(element).attr("data-marker").split(",");
				markers.push([$(element).attr("data-name"), lat, lng]);
			});

			// Info Window Content
			// var infoWindowContent = [
			// 	['<div class="info_content">' +
			// 		'<h3>London Eye</h3>' +
			// 		'<p>The London Eye is a giant Ferris wheel situated on the banks of the River Thames. The entire structure is 135 metres (443 ft) tall and the wheel has a diameter of 120 metres (394 ft).</p>' + '</div>'],
			// 	['<div class="info_content">' +
			// 		'<h3>Palace of Westminster</h3>' +
			// 		'<p>The Palace of Westminster is the meeting place of the House of Commons and the House of Lords, the two houses of the Parliament of the United Kingdom. Commonly known as the Houses of Parliament after its tenants.</p>' +
			// 		'</div>']
			// ];

			// Display multiple markers on a map
			let infoWindow = new google.maps.InfoWindow();
			let marker;
			let i;

			// Loop through our array of markers & place each one on the map
			for (i = 0; i < markers.length; i++) {
				var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
				bounds.extend(position);
				marker = new google.maps.Marker({
					position: position,
					map: map,
					title: markers[i][0]
				});

				// // Allow each marker to have an info window
				// google.maps.event.addListener(marker, 'click', (function (marker, i) {
				// 	return function () {
				// 		infoWindow.setContent(infoWindowContent[i][0]);
				// 		infoWindow.open(map, marker);
				// 	}
				// })(marker, i));

				// Automatically center the map fitting all markers on the screen
				map.fitBounds(bounds);
			}
		}

		var script = document.createElement("script");
		script.src =
			"//maps.googleapis.com/maps/api/js?key=AIzaSyD-pfyctn5j_Rfuj-wF8kkc3WivRhPuEgk&sensor=false&callback=initializeCoachesMap";
		document.body.appendChild(script);
	}

	// Conditionally show coaches based od their type
	$("#coach-type").on("change", function () {
		if ($("#coach-type").val() === "leader") {
			$(".PEOPLE-LIST__person").hide();
			$('[data-person-type~="leader"]').show();
		} else if ($("#coach-type").val() === "basic") {
			$(".PEOPLE-LIST__person").hide();
			$('[data-person-type~="basic"]').show();
		} else {
			$(".PEOPLE-LIST__person").show();
		}
	});
});
